import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import UserTargeting from "components/Monitoring/UserTargeting";
import Monitoring from "components/Monitoring/Monitoring";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as nextMonitoringReducer from "containers/Next/Monitoring/NextMonitoringReducer";

import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import { AIBLE_VIEW_TYPE } from "containers/Project/reducer";
import { UNIFIED_PROJECT_STEPS } from "containers/UnifiedProject/reducer";

class UserTargetingContainer extends React.Component {
  render() {
    return <UserTargeting {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const nextId = dispatch((dispatch, getState) => {
    return nextReducer.getNextIdFromProjectId(getState(), ownProps.id);
  });
  return {
    adjustAssumptions: () => dispatch(projectReducer.setAibleViewType(ownProps.id, AIBLE_VIEW_TYPE.BUSINESS)),
    deleteUserFeedback: (userId) => dispatch(monitoringReducer.deleteUserFeedback(ownProps.id, userId)),
    updateMonitorViewMode: (mode) => dispatch(monitoringReducer.updateMonitorViewMode(ownProps.id, mode)),
    adjustAdvancedOptions: () => {
      dispatch(unifiedProjectReducer.updateSkipToAdvancedOptions(ownProps.id, true));
      dispatch(unifiedProjectReducer.updateCurrentStep(ownProps.id, UNIFIED_PROJECT_STEPS.DEPLOY.id));
    },
    updateUserGroupValue: (index, key, value) =>
      dispatch(nextMonitoringReducer.updateUserGroupValue(nextId, index, key, value)),
    deleteUserTargeting: () => dispatch(nextMonitoringReducer.deleteUserTargeting(nextId)),
    saveUserTargeting: () => dispatch(nextMonitoringReducer.saveUserTargeting(nextId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const monitor = monitoringReducer.getMonitor(state, ownProps.id);
  const selectedRunId = projectReducer.getRunId(state, ownProps.id);
  const segmentId = projectReducer.getSegmentId(state, ownProps.id);
  const nextId = nextReducer.getNextIdFromProjectId(state, ownProps.id);
  return {
    nextId: nextId,
    monitorViewMode: monitoringReducer.getMonitorViewMode(state, ownProps.id),
    isContinuous: projectReducer.getIsContinuous(state, ownProps.id),
    userData: monitoringReducer.getUserData(state, ownProps.id),
    segmentId: segmentId,
    runId: selectedRunId,
    setupLabels: setupReducer.getSetupLabels(state, selectedRunId),
    scenarioIndex: getIsMonitoringDemo() ? projectReducer.getViewingScenarioIndex(state, ownProps.id) : undefined,
    deployedScenarioIndex: projectReducer.getDeployedScenarioIndex(state, ownProps.id),
    allScenarios: projectReducer.getAllScenarios(state, ownProps.id),
    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId),
    isOverallSegment: projectReducer.getIsOverallSegment(state, ownProps.id, selectedRunId),
    hasUserComplianceData: monitoringReducer.getHasUserComplianceData(state, ownProps.id),
    businessPredictionName: projectReducer.getBusinessPredictionName(state, ownProps.id),
    userTargeting: nextMonitoringReducer.getUserTargeting(state, nextId),
    users: adminReducer.getUsers(state),
    userTargetingPlot: nextMonitoringReducer.getUserTargetingPlot(state, nextId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(UserTargetingContainer);
